export default {
  AL: { name: "Alabama", population: 4908621 },
  AS: { name: "American Samoa", population: 55641, populationCensusYear: 2017 },
  AK: { name: "Alaska", population: 734002, hospitalBeds: 1615 },
  AZ: { name: "Arizona", population: 7378494, hospitalBeds: 14019 },
  AR: { name: "Arkansas", population: 3038999, hospitalBeds: 9725 },
  CA: { name: "California", population: 39937489, hospitalBeds: 71887 },
  CO: { name: "Colorado", population: 5845526, hospitalBeds: 11106 },
  CT: { name: "Connecticut", population: 3563077, hospitalBeds: 7126 },
  DE: { name: "Delaware", population: 982895, hospitalBeds: 2162 },
  DC: { name: "District Of Columbia", population: 720687 },
  FL: { name: "Florida", population: 21992985, hospitalBeds: 57182 },
  FM: { name: "Federated States of Micronesia", population: 105544, populationCensusYear: 2017 },
  GA: { name: "Georgia", population: 10736059, hospitalBeds: 25767 },
  GU: { name: "Guam", population: 164229, populationCensusYear: 2017 },
  HI: { name: "Hawaii", population: 1412687, hospitalBeds: 2684 },
  ID: { name: "Idaho", population: 1826156, hospitalBeds: 3470 },
  IL: { name: "Illinois", population: 12659682, hospitalBeds: 31649 },
  IN: { name: "Indiana", population: 6745354, hospitalBeds: 18212 },
  IA: { name: "Iowa", population: 3179849, hospitalBeds: 9540 },
  KS: { name: "Kansas", population: 2910357, hospitalBeds: 9604 },
  KY: { name: "Kentucky", population: 4499692, hospitalBeds: 14399 },
  LA: { name: "Louisiana", population: 4645184, hospitalBeds: 15329 },
  ME: { name: "Maine", population: 1345790, hospitalBeds: 3364 },
  MD: { name: "Maryland", population: 6083116, hospitalBeds: 11558 },
  MA: { name: "Massachusetts", population: 6976597, hospitalBeds: 16046 },
  MH: { name: "Marshall Islands", population: 53127, populationCensusYear: 2017 },
  MI: { name: "Michigan", population: 10045029, hospitalBeds: 25113 },
  MN: { name: "Minnesota", population: 5700671, hospitalBeds: 14252 },
  MS: { name: "Mississippi", population: 2989260, hospitalBeds: 11957 },
  MO: { name: "Missouri", population: 6169270, hospitalBeds: 19125 },
  MP: { name: "Northern Marina Islands", population: 55144, populationCensusYear: 2017 },
  MT: { name: "Montana", population: 1086759, hospitalBeds: 3586 },
  NE: { name: "Nebraska", population: 1952570, hospitalBeds: 7029 },
  NV: { name: "Nevada", population: 3139658, hospitalBeds: 6593 },
  NH: { name: "New Hampshire", population: 1371246, hospitalBeds: 2880 },
  NJ: { name: "New Jersey", population: 8936574, hospitalBeds: 21448 },
  NM: { name: "New Mexico", population: 2096640, hospitalBeds: 3774 },
  NY: { name: "New York", population: 19440469, hospitalBeds: 52489 },
  NC: { name: "North Carolina", population: 10611862, hospitalBeds: 22285 },
  ND: { name: "North Dakota", population: 761723, hospitalBeds: 3275 },
  OH: { name: "Ohio", population: 11747694, hospitalBeds: 32894 },
  OK: { name: "Oklahoma", population: 3954821, hospitalBeds: 11073 },
  OR: { name: "Oregon", population: 4301089, hospitalBeds: 6882 },
  PA: { name: "Pennsylvania", population: 12820878, hospitalBeds: 37181 },
  PW: { name: "Palau", population: 21729, populationCensusYear: 2017 },
  PR: { name: "Puerto Rico", population: 3032165 },
  RI: { name: "Rhode Island", population: 1056161, hospitalBeds: 2218 },
  SC: { name: "South Carolina", population: 5210095, hospitalBeds: 12504 },
  SD: { name: "South Dakota", population: 903027, hospitalBeds: 4335 },
  TN: { name: "Tennessee", population: 6897576, hospitalBeds: 20003 },
  TX: { name: "Texas", population: 29472295, hospitalBeds: 67786 },
  UT: { name: "Utah", population: 3282115, hospitalBeds: 5908 },
  VT: { name: "Vermont", population: 628061, hospitalBeds: 1319 },
  VA: { name: "Virginia", population: 8626207, hospitalBeds: 18115 },
  VI: { name: "Virgin Islands", population: 10768, populationCensusYear: 2017 },
  WA: { name: "Washington", population: 7797095, hospitalBeds: 13255 },
  WV: { name: "West Virginia", population: 1778070, hospitalBeds: 6757 },
  WI: { name: "Wisconsin", population: 5851754, hospitalBeds: 12289 },
  WY: { name: "Wyoming", population: 567025, hospitalBeds: 1985 }
}
